import { render, staticRenderFns } from "./UntaggedTransactions.vue?vue&type=template&id=71f98b2a&scoped=true"
import script from "./UntaggedTransactions.vue?vue&type=script&lang=js"
export * from "./UntaggedTransactions.vue?vue&type=script&lang=js"
import style0 from "./UntaggedTransactions.vue?vue&type=style&index=0&id=71f98b2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f98b2a",
  null
  
)

export default component.exports